var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatedTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.99999H2",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.99999H2",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 6.99999H1.3335",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75732 2.75732C5.47331 1.04133 8.05402 0.527998 10.2961 1.45668C12.5381 2.38537 14 4.57319 14 6.99996C14 9.42674 12.5381 11.6146 10.2961 12.5432C8.05402 13.4719 5.47331 12.9586 3.75732 11.2426",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 3.99999V4.60588",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.81769C6.58763 5.07326 7.25378 4.5351 8 4.60589",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 9.99999V9.3941",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.18231C9.41237 8.92674 8.74622 9.4649 8 9.39411",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46181 5.55335C9.23612 4.95027 8.64267 4.56563 8 4.60591",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53857 8.44666C6.76426 9.04974 7.35771 9.43437 8.00038 9.3941",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.81766V5.81766C6.50001 6.33068 6.86212 6.77238 7.36518 6.87299L8.63482 7.12692C9.13788 7.22753 9.49999 7.66924 9.5 8.18226V8.18226",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedTransactions);
export default __webpack_public_path__ + "static/media/RelatedTransactions.2eaaa915358d5f84dfee6ba266fad497.svg";
export { ForwardRef as ReactComponent };